import React, { useEffect, useRef, useState } from 'react';
import './AboutUs.css';

const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the component is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about-us" className="about-us" ref={sectionRef}>
      <div className="about-us-container">
        {/* Left Section: Text Content */}
        <div className={`about-us-text ${isVisible ? 'animate' : ''}`}>
          <div className="about-us-header">
            <img src="/images/About_us_icon.png" alt="Megaphone Icon" className="megaphone-icon" />
            <h2>QUI SOMMES-NOUS ?</h2>
          </div>
          <p className="about-us-description">
            La société EM PACK ,est spécialisée dans la fabrication d’emballages personnalisés. Nous vous garantissons une réalisation sur mesure répondant à vos exigences ainsi qu’aux normes de fabrication.
          </p>
          <p className="about-us-description">
            Nous proposons différentes solutions d’emballages pour tous secteurs d’activités, qu’ils soient en carton, papier, plastique ou même en tissu.
          </p>
          <div className="about-us-qualities">
            <div className="quality-item">
              <span className="checkmark">✔</span> Professionnalisme
            </div>
            <div className="quality-item">
              <span className="checkmark">✔</span> Créativité
            </div>
            <div className="quality-item">
              <span className="checkmark">✔</span> Adaptabilité
            </div>
            <div className="quality-item">
              <span className="checkmark">✔</span> Respect des normes en vigueur
            </div>
          </div>
        </div>

        {/* Right Section: Overlapping Images */}
        <div className={`about-us-images ${isVisible ? 'animate-images' : ''}`}>
          <div className="image-wrapper">
            <img src="/images/about-us-1.jpg" alt="Packaging Background" className="background-image" />
            <img src="/images/about-us-2.jpg" alt="Packaging Foreground" className="foreground-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;